module.exports = __webpack_public_path__ + "img/Foaming_stock.23d19b58.svg";